import React, { useEffect, useState } from 'react';
import { LoginSourceTypes, SystemAccessTypes } from '@arema/components/Classes';
import { Checkbox, Table } from 'react-frontier2';

const SYSTEM_ACCESS : {
	[x in LoginSourceTypes]?: {
		name: string,
		description: string,
	}
} = {
	ADMIN: {
		name: 'Admin',
		description: 'Acceso al administrador web'
	},
	OPERATIONS: {
		name: 'Operaciones',
		description: 'Acceso al sistema web de administrador de operaciones'
	},
	REPORTS: {
		name: 'Reportes',
		description: 'Acceso al sistema de reportes para empresarios'
	},
	PDV: {
		name: 'PDV',
		description: 'Acceso al PDV de venta de boletos en taquilla'
	},
	SCANNER: {
		name: 'Scanners',
		description: 'Acceso a la aplicación de checadores de boletos'
	}
}

const SYSTEM_ACCESS_LOCALE : {
	[x: number]: string
} = {
	2: 'Admin',
	3: 'Operaciones',
	5: 'Reportes',
	20: 'PDV',
	21: 'Scanner'
}

interface SystemAccessRowProps{
	system: SystemAccessTypes,
	value: boolean,
	action?: JSX.Element,
	onChange: (v: boolean)=>void,
}

type SystemAccessRowSubcomponents = {
	Types: typeof SYSTEM_ACCESS,
	Locale: typeof SYSTEM_ACCESS_LOCALE,
}

const SystemAccessRow : React.FC<SystemAccessRowProps> & SystemAccessRowSubcomponents = (props: SystemAccessRowProps)=>{
	var system = SYSTEM_ACCESS[props.system];
	if(!system) return null;

	return <Table.Row
		collapsingIndexes={[0, 2]}
	>
		<Table.Cell collapsing>
			<Checkbox checked={!!props.value} onChange={props.onChange} color='orange' />
		</Table.Cell>
		<Table.Cell colSpan={!props.action ? 2 : 1}>
			<div className="access">
				<div className="name" style={{ fontWeight: 'bold', fontSize: 16, lineHeight: '18px' }}>{system.name}</div>
				<div className="description" style={{ color: 'gray' }}>{system.description}</div>
			</div>
		</Table.Cell>
		{!!props.action && (
			<Table.Cell collapsing>
				{props.action}
			</Table.Cell>
		)}
	</Table.Row>
}

SystemAccessRow.Types = SYSTEM_ACCESS;
SystemAccessRow.Locale = SYSTEM_ACCESS_LOCALE;

export default SystemAccessRow;